
import Commande_Inscription from "./Commande_Inscription.class.js";
import UserService from "../../services/user.service";

/**
 * @classdesc Une commande effectuée par un client
 * @kind class
 * @export
 * @class Commande
 */
export default class Commande {
    id;
    uuid;
    cycle;
    exclude_taxe;
    id_account;
    id_module;
    nb_articles;
    prix;
    prix_total;
    statut;
    taxe;
    mail;
    list_commandes_inscriptions_coureur = [];

    /**
     * Creates an instance of Commande.
     * @constructs
     * @kind function
     * @memberof Commande
     */
    constructor() { }

    async get_by_crypted_uuid(uuid) {
        this.list_commandes_inscriptions_coureur = [];
        let res = await UserService.getCommandeByCryptedUUID(uuid);
        if (res) {
            this.set(res);
            return true;
        }
        return false;

    }
    async get() {
        this.list_commandes_inscriptions_coureur = [];
        let res = await UserService.getCommande(this.id);
        if (res) {
            this.set(res);
            return true;
        }
        return false;

    }


    set(data) {
        this.id = data.id;
        this.uuid = data.uuid;
        this.cycle = data.cycle;
        this.exclude_taxe = data.exclude_taxe;
        this.id_account = data.id_account;
        this.id_module = data.id_module;
        this.nb_articles = data.nb_articles;
        this.prix = data.prix;
        this.prix_total = data.prix_total;
        this.statut = data.statut;
        this.taxe = data.taxe;
        this.mail = data.mail;
        this.account = data.account;
        if (data.list_commandes_inscriptions_coureur) {
            this.list_commandes_inscriptions_coureur = [];
            for (let i = 0; i < data.list_commandes_inscriptions_coureur.length; i++) {
                let commande_inscription = new Commande_Inscription();
                commande_inscription.set(data.list_commandes_inscriptions_coureur[i]);
                this.list_commandes_inscriptions_coureur.push(commande_inscription);
            }
        }

    }
}